import React, { useEffect, useState, useRef } from "react";
import { Container, Row, Col, Card, Button, Form, Alert, Badge, Spinner, Table } from "react-bootstrap";
import { alterarConfiguracao, pegarConfiguracao } from "../data/api/gsConnectApi";
import { AgendaSelect2Component } from "components/select2/agendaSelect2Component";
import { ProcedimentosSelect2Component } from "components/select2/procedimentosSelect2Component";
import { StatusSelect2Component } from "components/select2/statusSelect2Component";
import { DiasAntesSelect2Component } from "components/select2/diasAntesSelect2Component";
import { DiasSemanaSelect2Component } from "components/select2/diasSemanaSelect2Component";
import { useHistory } from 'react-router-dom';
import Select from 'react-select';

function AutomacoesView() {
  const [mensagemSucesso, setMensagemSucesso] = useState('');
  const [mensagemErro, setMensagemErro] = useState('');

  const showSuccess = (message) => {
    setMensagemSucesso(message);
    setTimeout(() => setMensagemSucesso(''), 3000);
  };

  const showError = (message) => {
    setMensagemErro(message);
    setTimeout(() => setMensagemErro(''), 5000);
  };

  // Estatísticas das automações
  const [stats, setStats] = useState({
    aniversarios: false,
    confirmacoes: false,
    lembretes: false,
    preCadastros: false,
    preCadastroDoadora: false,
    cobrancaCongelados: false
  });

  useEffect(() => {
    // Carregar status das automações para estatísticas
    const carregarStats = async () => {
      try {
        const [aniv, conf, lemb, pre, cobranca] = await Promise.all([
          pegarConfiguracao('AUTOMACAO_ANIVERSARIANTES'),
          pegarConfiguracao('AUTOMACAO_CONFIRMACAO_AGENDAMENTO'),
          pegarConfiguracao('AUTOMACAO_LEMBRETE_AGENDAMENTO'),
          pegarConfiguracao('AUTOMACAO_PRE_CADASTRO_AGENDAMENTO'),
          pegarConfiguracao('AUTOMACAO_PRE_CADASTRO_DOADORA_AGENDAMENTO'),
          pegarConfiguracao('AUTOMACAO_COBRANCA_CONGELADOS')
        ]);

        setStats({
          aniversarios: aniv?.valor === 'true',
          confirmacoes: conf?.valor === 'true',
          lembretes: lemb?.valor === 'true',
          preCadastros: pre?.valor === 'true',
          preCadastroDoadora: preDoadora?.valor === 'true',
          cobrancaCongelados: cobranca?.valor === 'true'
        });
      } catch (error) {
        console.error('Erro ao carregar estatísticas:', error);
      }
    };

    carregarStats();
  }, []);

  const totalAtivas = Object.values(stats).filter(Boolean).length;

  const statCards = [
    { value: totalAtivas, label: 'Automações Ativas', icon: '🤖', color: '#43a047' },
    { value: stats.aniversarios ? 1 : 0, label: 'Aniversários', icon: '🎂', color: '#43a047' },
    { value: stats.confirmacoes ? 1 : 0, label: 'Confirmações', icon: '✅', color: '#43a047' },
    { value: stats.lembretes ? 1 : 0, label: 'Lembretes', icon: '⏰', color: '#43a047' },
    { value: stats.preCadastros ? 1 : 0, label: 'Pré-Cadastros', icon: '📋', color: '#43a047' },
    { value: stats.preCadastroDoadora ? 1 : 0, label: 'Pré-Cadastros Doadora', icon: '📋', color: '#43a047' },
    { value: stats.cobrancaCongelados ? 1 : 0, label: 'Cobrança Congelados', icon: '💰', color: '#43a047' },
    { value: '08:00', label: 'Horário Aniversários', icon: '🕐', color: '#43a047' }
  ];

  const history = useHistory();

  return (
    <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }} >
      {/* Header seguindo padrão */}
      <div style={{ backgroundColor: '#43a047', color: 'white', padding: '12px 20px', fontSize: '16px', fontWeight: '500' }}>
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <Button variant="outline-light" size="sm" style={{ borderColor: 'white', color: 'white', marginRight: 12 }} onClick={() => history.push('/admin/home')}>
              ← Voltar
            </Button>
            <span>Automações</span>
          </div>
          <Badge bg="primary" className="px-3 py-2">
            {totalAtivas} ativas
          </Badge>
        </div>
      </div>

      <Container fluid className="p-3">
        {/* Alerts */}
        {mensagemSucesso && (
          <Alert variant="success" className="mb-3" dismissible onClose={() => setMensagemSucesso('')}>
            ✅ {mensagemSucesso}
          </Alert>
        )}
        {mensagemErro && (
          <Alert variant="danger" className="mb-3" dismissible onClose={() => setMensagemErro('')}>
            ❌ {mensagemErro}
          </Alert>
        )}

        {/* Cards de Estatísticas - 2 linhas com 4 cards cada */}
        <Row className="mb-3">
          {statCards.map((stat, index) => (
            <Col xl={3} lg={4} md={6} key={index} className="mb-3 ml-3">
              <Card className="text-center h-100" style={{ backgroundColor: stat.color, color: 'white' }}>
                <Card.Body className="py-3">
                  <div style={{ fontSize: '2rem', marginBottom: '8px' }}>{stat.icon}</div>
                  <h4 className="mb-1">{stat.value}</h4>
                  <small>{stat.label}</small>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Automação de Aniversários */}
        <div className="bg-white mb-3" style={{ border: '1px solid #dee2e6' }}>
          <div style={{ backgroundColor: '#f8f9fa', padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>
            <h6 className="mb-0" style={{ color: '#495057', fontWeight: '600' }}>🎂 Enviar mensagens de aniversário automaticamente</h6>
          </div>
          <div className="p-3">
            <Row className="align-items-center">
              <Col md={2}>
                <Form.Label className="small fw-medium text-muted">Habilitado:</Form.Label>
              </Col>
              <Col md={3}>
                <ConfiguracaoSwitch
                  tipo="AUTOMACAO_ANIVERSARIANTES"
                  onSuccess={showSuccess}
                  onError={showError}
                  onToggle={(value) => setStats(prev => ({ ...prev, aniversarios: value }))}
                />
              </Col>
              <Col md={7}>
                <small className="text-muted">
                  <strong>⏰ Horário:</strong> As mensagens serão enviadas todos os dias às 08:00
                </small>
              </Col>
            </Row>
          </div>
        </div>

        {/* Configurações de Agendamento */}
        <ConfiguracaoAgendamento
          titulo="📅 Enviar confirmações de agendamentos automaticamente"
          configuracao="AUTOMACAO_CONFIRMACAO_AGENDAMENTO_CONFIGURACAO"
          configuracaoHabilitar="AUTOMACAO_CONFIRMACAO_AGENDAMENTO"
          onSuccess={showSuccess}
          onError={showError}
          onToggle={(value) => setStats(prev => ({ ...prev, confirmacoes: value }))}
        />

        <ConfiguracaoAgendamento
          titulo="⏰ Enviar lembretes de agendamentos automaticamente"
          configuracao="AUTOMACAO_LEMBRETE_AGENDAMENTO_CONFIGURACAO"
          configuracaoHabilitar="AUTOMACAO_LEMBRETE_AGENDAMENTO"
          onSuccess={showSuccess}
          onError={showError}
          onToggle={(value) => setStats(prev => ({ ...prev, lembretes: value }))}
        />

        <ConfiguracaoAgendamento
          titulo="📋 Enviar pré cadastro automaticamente (Apenas pacientes sem cadastro)"
          configuracao="AUTOMACAO_PRE_CADASTRO_AGENDAMENTO_CONFIGURACAO"
          configuracaoHabilitar="AUTOMACAO_PRE_CADASTRO_AGENDAMENTO"
          onSuccess={showSuccess}
          onError={showError}
          onToggle={(value) => setStats(prev => ({ ...prev, preCadastros: value }))}
        />

        <ConfiguracaoAgendamento
          titulo="📋 Enviar pré cadastro de doadora automaticamente (Apenas pacientes sem cadastro)"
          configuracao="AUTOMACAO_PRE_CADASTRO_DOADORA_AGENDAMENTO_CONFIGURACAO"
          configuracaoHabilitar="AUTOMACAO_PRE_CADASTRO_DOADORA_AGENDAMENTO"
          onSuccess={showSuccess}
          onError={showError}
          onToggle={(value) => setStats(prev => ({ ...prev, preCadastroDoadora: value }))}
        />

        {/* Configuração de Cobrança de Congelados */}
        <ConfiguracaoCobrancaCongelados
          onSuccess={showSuccess}
          onError={showError}
          onToggle={(value) => setStats(prev => ({ ...prev, cobrancaCongelados: value }))}
        />
      </Container>
    </div>
  );
}

// Componente Switch de Configuração
const ConfiguracaoSwitch = ({ tipo, onSuccess, onError, onToggle }) => {
  const [checked, setChecked] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    pegarConfiguracao(tipo).then((dados) => {
      const value = dados.valor === 'true';
      console.log(`Carregando ${tipo}:`, dados, 'valor:', value);
      setChecked(value);
    }).catch(erro => {
      console.error('Erro ao carregar configuração:', erro);
    });
  }, [tipo]);

  const handleChange = async (event) => {
    const newValue = event.target.checked;
    console.log(`Alterando ${tipo} para:`, newValue);
    setLoading(true);

    try {
      const resultado = await alterarConfiguracao(tipo, newValue.toString());
      console.log(`Resultado da alteração ${tipo}:`, resultado);
      setChecked(newValue);
      onToggle && onToggle(newValue);
      onSuccess('Configuração salva com sucesso!');
    } catch (error) {
      console.error(`Erro ao salvar ${tipo}:`, error);
      onError('Erro ao salvar configuração.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form.Check
      type="switch"
      id={`switch-${tipo}`}
      checked={checked}
      onChange={handleChange}
      disabled={loading}
      style={{ fontSize: '14px' }}
      label={loading ? "Salvando..." : ""}
    />
  );
};


// Componente principal de configuração de agendamento
const ConfiguracaoAgendamento = ({ titulo, configuracao, configuracaoHabilitar, onSuccess, onError, onToggle }) => {
  const [configuracoes, setConfiguracoes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editando, setEditando] = useState(false);
  const [indiceEditando, setIndiceEditando] = useState(null);

  const agendasRef = useRef();
  const procedimentosRef = useRef();
  const statusRef = useRef();
  const diasAntesRef = useRef();
  const horarioEnvioRef = useRef();
  const mensagemRef = useRef();
  const diasSemanaRef = useRef();

  useEffect(() => {
    carregarConfiguracoes();
  }, [configuracao]);

  const carregarConfiguracoes = async () => {
    try {
      const dados = await pegarConfiguracao(configuracao);
      const configs = dados?.valor ? JSON.parse(dados.valor) : [];
      setConfiguracoes(Array.isArray(configs) ? configs : []);
    } catch (error) {
      console.error('Erro ao carregar configurações:', error);
      setConfiguracoes([]);
    }
  };

  const salvarConfiguracoes = async (novasConfigs) => {
    try {
      await alterarConfiguracao(configuracao, JSON.stringify(novasConfigs));
      setConfiguracoes(novasConfigs);
    } catch (error) {
      onError('Erro ao salvar configurações.');
    }
  };

  const limparFormulario = () => {
    agendasRef.current?.setValue(null);
    procedimentosRef.current?.setValue(null);
    statusRef.current?.setValue(null);
    diasAntesRef.current?.setValue(null);
    diasSemanaRef.current?.setValue(null);
    if (horarioEnvioRef.current) horarioEnvioRef.current.value = '';
    if (mensagemRef.current) mensagemRef.current.value = '';
    setEditando(false);
    setIndiceEditando(null);
  };

  const carregarParaEdicao = (config, index) => {
    setEditando(true);
    setIndiceEditando(index);

    // Carregar dados nos campos
    if (agendasRef.current) {
      agendasRef.current.setValue([{
        value: config.Agenda.id,
        label: config.Agenda.Nome
      }]);
    }

    if (procedimentosRef.current) {
      procedimentosRef.current.setValue(config.Procedimentos.map(p => ({
        value: p.id,
        label: p.Nome
      })));
    }

    if (statusRef.current) {
      statusRef.current.setValue(config.Status.map(s => ({
        value: s.id,
        label: s.Nome
      })));
    }

    if (diasAntesRef.current) {
      diasAntesRef.current.setValue([{
        value: config.DiasAntes,
        label: config.DiasAntesLabel
      }]);
    }

    if (horarioEnvioRef.current) {
      horarioEnvioRef.current.value = config.HorarioEnvio;
    }

    if (mensagemRef.current) {
      mensagemRef.current.value = config.MensagemConteudo || '';
    }

    if (diasSemanaRef.current && config.DiasSemana) {
      // Converter para o formato do Select2 (value/label)
      const diasSelect2 = config.DiasSemana.map(dia => ({
        value: dia.value || dia.id || dia,
        label: dia.label || dia.nome || getDiaNome(dia.value || dia.id || dia)
      }));
      diasSemanaRef.current.setValue(diasSelect2);
    }
  };

  const duplicarConfiguracao = (config) => {
    // Limpar modo de edição se estiver ativo
    setEditando(false);
    setIndiceEditando(null);

    // Carregar dados nos campos para duplicação
    if (agendasRef.current) {
      agendasRef.current.setValue([{
        value: config.Agenda.id,
        label: config.Agenda.Nome
      }]);
    }

    if (procedimentosRef.current) {
      procedimentosRef.current.setValue(config.Procedimentos.map(p => ({
        value: p.id,
        label: p.Nome
      })));
    }

    if (statusRef.current) {
      statusRef.current.setValue(config.Status.map(s => ({
        value: s.id,
        label: s.Nome
      })));
    }

    if (diasAntesRef.current) {
      diasAntesRef.current.setValue([{
        value: config.DiasAntes,
        label: config.DiasAntesLabel
      }]);
    }

    if (horarioEnvioRef.current) {
      horarioEnvioRef.current.value = config.HorarioEnvio;
    }

    if (mensagemRef.current) {
      mensagemRef.current.value = config.MensagemConteudo || '';
    }

    if (diasSemanaRef.current && config.DiasSemana) {
      // Converter para o formato do Select2 (value/label)
      const diasSelect2 = config.DiasSemana.map(dia => ({
        value: dia.value || dia.id || dia,
        label: dia.label || dia.nome || getDiaNome(dia.value || dia.id || dia)
      }));
      diasSemanaRef.current.setValue(diasSelect2);
    }

    onSuccess('Configuração carregada para duplicação. Ajuste os campos necessários e clique em "Adicionar".');
  };

  const cancelarEdicao = () => {
    limparFormulario();
  };

  const getDiaNome = (id) => {
    const dias = {
      'TodosDias': 'Todos os dias',
      1: 'Domingo',
      2: 'Segunda-feira',
      3: 'Terça-feira',
      4: 'Quarta-feira',
      5: 'Quinta-feira',
      6: 'Sexta-feira',
      7: 'Sábado'
    };
    return dias[id] || 'Desconhecido';
  };

  const getDiaAbreviacao = (nome) => {
    const abrevs = {
      'Todos os dias': 'Todos',
      'Domingo': 'Dom',
      'Segunda-feira': 'Seg',
      'Terça-feira': 'Ter',
      'Quarta-feira': 'Qua',
      'Quinta-feira': 'Qui',
      'Sexta-feira': 'Sex',
      'Sábado': 'Sáb'
    };
    return abrevs[nome] || nome.substring(0, 3);
  };

  const adicionarConfiguracao = async () => {
    setLoading(true);

    try {
      const agendasSelecionadas = agendasRef.current?.getValue() || [];
      const procedimentosSelecionadas = procedimentosRef.current?.getValue() || [];
      const statusSelecionadas = statusRef.current?.getValue() || [];
      const diasAntesSelecionadas = diasAntesRef.current?.getValue() || [];
      const diasSemanaSelecionados = diasSemanaRef.current?.getValue() || [];
      const horarioEnvio = horarioEnvioRef.current?.value;
      const mensagemConteudo = mensagemRef.current?.value;

      // Validações
      if (agendasSelecionadas.length === 0) {
        onError('Selecione uma agenda.');
        return;
      }
      if (procedimentosSelecionadas.length === 0) {
        onError('Selecione um procedimento.');
        return;
      }
      if (statusSelecionadas.length === 0) {
        onError('Selecione um status.');
        return;
      }
      if (diasAntesSelecionadas.length === 0) {
        onError('Selecione dias antes.');
        return;
      }
      if (!horarioEnvio) {
        onError('Preencha o horário de envio.');
        return;
      }
      if (diasSemanaSelecionados.length === 0) {
        onError('Selecione pelo menos um dia da semana.');
        return;
      }

      const novaConfiguracao = {
        Agenda: {
          Nome: agendasSelecionadas[0].label,
          id: agendasSelecionadas[0].value,
        },
        Procedimentos: procedimentosSelecionadas.map(p => ({ Nome: p.label, id: p.value })),
        Status: statusSelecionadas.map(s => ({ Nome: s.label, id: s.value })),
        DiasAntes: diasAntesSelecionadas[0].value,
        DiasAntesLabel: diasAntesSelecionadas[0].label,
        DiasSemana: diasSemanaSelecionados,
        HorarioEnvio: horarioEnvio,
        MensagemConteudo: mensagemConteudo
      };

      let configsAtualizadas;

      if (editando && indiceEditando !== null) {
        // Modo edição - atualizar configuração existente
        configsAtualizadas = [...configuracoes];
        configsAtualizadas[indiceEditando] = novaConfiguracao;
        await salvarConfiguracoes(configsAtualizadas);
        onSuccess('Configuração atualizada com sucesso!');
      } else {
        // Modo adição - adicionar nova configuração
        const novasConfiguracoes = agendasSelecionadas.map(agenda => ({
          Agenda: {
            Nome: agenda.label,
            id: agenda.value,
          },
          Procedimentos: procedimentosSelecionadas.map(p => ({ Nome: p.label, id: p.value })),
          Status: statusSelecionadas.map(s => ({ Nome: s.label, id: s.value })),
          DiasAntes: diasAntesSelecionadas[0].value,
          DiasAntesLabel: diasAntesSelecionadas[0].label,
          DiasSemana: diasSemanaSelecionados,
          HorarioEnvio: horarioEnvio,
          MensagemConteudo: mensagemConteudo
        }));

        configsAtualizadas = [...configuracoes, ...novasConfiguracoes];
        await salvarConfiguracoes(configsAtualizadas);
        onSuccess('Configuração adicionada com sucesso!');
      }

      // Limpar campos
      limparFormulario();
    } catch (error) {
      onError('Erro ao adicionar configuração.');
    } finally {
      setLoading(false);
    }
  };

  const removerConfiguracao = async (index) => {
    if (!window.confirm('Tem certeza que deseja excluir esta configuração?')) {
      return;
    }

    const novasConfigs = [...configuracoes];
    novasConfigs.splice(index, 1);
    await salvarConfiguracoes(novasConfigs);
    onSuccess('Configuração removida com sucesso!');
  };

  return (
    <div className="bg-white mb-3" style={{ border: '1px solid #dee2e6' }}>
      <div style={{ backgroundColor: '#f8f9fa', padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>
        <h6 className="mb-0" style={{ color: '#495057', fontWeight: '600' }}>{titulo}</h6>
      </div>
      <div className="p-3">
        {/* Switch para habilitar/desabilitar */}
        <Row className="align-items-center mb-3">
          <Col md={2}>
            <Form.Label className="small fw-medium text-muted">Habilitado:</Form.Label>
          </Col>
          <Col md={3}>
            <ConfiguracaoSwitch
              tipo={configuracaoHabilitar}
              onSuccess={onSuccess}
              onError={onError}
              onToggle={onToggle}
            />
          </Col>
        </Row>

        {/* Indicador de modo de edição */}
        {editando && (
          <Alert variant="info" className="mb-3" style={{ fontSize: '13px' }}>
            ✏️ <strong>Modo de edição:</strong> Editando configuração #{indiceEditando + 1}
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={cancelarEdicao}
              style={{ float: 'right', fontSize: '11px' }}
            >
              Cancelar
            </Button>
          </Alert>
        )}

        {/* Indicador de modo de duplicação */}
        {!editando && (agendasRef.current?.getValue()?.length > 0 || procedimentosRef.current?.getValue()?.length > 0 || statusRef.current?.getValue()?.length > 0) && (
          <Alert variant="success" className="mb-3" style={{ fontSize: '13px' }}>
            📋 <strong>Modo de duplicação:</strong> Campos preenchidos com configuração existente. Ajuste conforme necessário e clique em "Adicionar".
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={limparFormulario}
              style={{ float: 'right', fontSize: '11px' }}
            >
              Limpar
            </Button>
          </Alert>
        )}

        {/* Formulário de adição/edição */}
        <Row className="mb-3">
          <Col md={3}>
            <Form.Label className="small fw-medium text-muted">Agenda</Form.Label>
            <AgendaSelect2Component ref={agendasRef} />
          </Col>
          <Col md={3}>
            <Form.Label className="small fw-medium text-muted">Procedimentos</Form.Label>
            <ProcedimentosSelect2Component ref={procedimentosRef} />
          </Col>
          <Col md={3}>
            <Form.Label className="small fw-medium text-muted">Status</Form.Label>
            <StatusSelect2Component ref={statusRef} />
          </Col>
          <Col md={3}>
            <Form.Label className="small fw-medium text-muted">Notifica</Form.Label>
            <DiasAntesSelect2Component ref={diasAntesRef} />
          </Col>
        </Row>

        {/* Seleção de dias da semana */}
        <Row className="mb-3">
          <Col md={3}>
            <Form.Label className="small fw-medium text-muted">Dias da semana para envio</Form.Label>
            <DiasSemanaSelect2Component ref={diasSemanaRef} />
          </Col>
        </Row>

        {/* Variáveis disponíveis */}
        <div className="mb-3">
          <small className="text-muted d-block mb-2"><strong>Variáveis disponíveis:</strong></small>
          <div className="d-flex flex-wrap gap-1">
            {['$nomePaciente', '$nomeProcedimento', '$nomeMedico', '$nomeDiaDaSemana', '$dataAgendamento', '$horarioAgendamento'].map((variavel, index) => (
              <Badge key={index} bg="light" text="dark" className="small">{variavel}</Badge>
            ))}
          </div>
        </div>

        {/* Mensagem personalizada */}
        <Row className="mb-3">
          <Col md={12}>
            <Form.Label className="small fw-medium text-muted">Mensagem personalizada</Form.Label>
            <Form.Control
              ref={mensagemRef}
              as="textarea"
              rows={3}
              placeholder="Digite a mensagem..."
              style={{ fontSize: '13px' }}
            />
          </Col>
        </Row>

        {/* Horário e botão adicionar/atualizar */}
        <Row className="align-items-end">
          <Col md={3}>
            <Form.Label className="small fw-medium text-muted">Horário de início dos envios</Form.Label>
            <Form.Control
              ref={horarioEnvioRef}
              type="time"
              size="sm"
              style={{ fontSize: '13px' }}
            />
          </Col>
          <Col md={2}>
            <Button
              variant={editando ? "warning" : "success"}
              onClick={adicionarConfiguracao}
              disabled={loading}
              style={{
                backgroundColor: editando ? '#ffc107' : '#43a047',
                borderColor: editando ? '#ffc107' : '#43a047',
                fontSize: '13px',
                color: editando ? '#000' : 'white',
                width: '100%'
              }}
            >
              {loading ? <Spinner size="sm" /> : (editando ? 'Atualizar' : 'Adicionar')}
            </Button>
          </Col>
        </Row>

        {/* Tabela de configurações */}
        {configuracoes.length > 0 && (
          <div className="mt-4">
            <div className="table-responsive">
              <Table className="mb-0" style={{ fontSize: '12px' }}>
                <thead style={{ backgroundColor: '#f8f9fa' }}>
                  <tr>
                    <th style={{ padding: '8px 12px', fontWeight: '600', color: '#495057' }}>Agenda</th>
                    <th style={{ padding: '8px 12px', fontWeight: '600', color: '#495057' }}>Procedimentos</th>
                    <th style={{ padding: '8px 12px', fontWeight: '600', color: '#495057' }}>Status</th>
                    <th style={{ padding: '8px 12px', fontWeight: '600', color: '#495057' }}>Dias antes</th>
                    <th style={{ padding: '8px 12px', fontWeight: '600', color: '#495057' }}>Dias da semana</th>
                    <th style={{ padding: '8px 12px', fontWeight: '600', color: '#495057' }}>Horário</th>
                    <th style={{ padding: '8px 12px', fontWeight: '600', color: '#495057' }}>Mensagem</th>
                    <th style={{ padding: '8px 12px', fontWeight: '600', color: '#495057', width: '150px' }}>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {configuracoes.map((config, index) => (
                    <tr key={index} style={{ borderBottom: '1px solid #f0f0f0' }}>
                      <td style={{ padding: '8px 12px', verticalAlign: 'top' }}>{config.Agenda?.Nome}</td>
                      <td style={{ padding: '8px 12px', verticalAlign: 'top' }}>
                        {config.Procedimentos?.map(p => p.Nome).join(', ')}
                      </td>
                      <td style={{ padding: '8px 12px', verticalAlign: 'top' }}>
                        {config.Status?.map(s => s.Nome).join(', ')}
                      </td>
                      <td style={{ padding: '8px 12px', verticalAlign: 'top' }}>{config.DiasAntesLabel}</td>
                      <td style={{ padding: '8px 12px', verticalAlign: 'top' }}>
                        <div className="d-flex flex-wrap" style={{ gap: '4px' }}>
                          {config.DiasSemana?.map((dia, idx) => (
                            <Badge
                              key={idx}
                              bg="primary"
                              style={{
                                fontSize: '12px',
                                backgroundColor: '#43a047',
                                borderRadius: '3px',
                                padding: '2px 4px',
                                color: 'white',
                                marginRight: '2px',
                                marginBottom: '2px'
                              }}
                            >
                              {getDiaAbreviacao(dia.label || dia.nome || getDiaNome(dia.value || dia.id || dia))}
                            </Badge>
                          )) || <small className="text-muted">Nenhum dia selecionado</small>}
                        </div>
                      </td>
                      <td style={{ padding: '8px 12px', verticalAlign: 'top' }}>{config.HorarioEnvio}</td>
                      <td style={{ padding: '8px 12px', verticalAlign: 'top', maxWidth: '200px' }}>
                        <div style={{
                          background: 'linear-gradient(135deg, #e8f5e8 0%, #c8e6c9 100%)',
                          padding: '6px 8px',
                          borderRadius: '4px',
                          borderLeft: '3px solid #43a047',
                          fontSize: '11px',
                          lineHeight: '1.3',
                          maxHeight: '60px',
                          overflowY: 'auto',
                          wordBreak: 'break-word'
                        }}>
                          {config.MensagemConteudo}
                        </div>
                      </td>
                      <td style={{ padding: '8px 12px', textAlign: 'center' }}>
                        <div className="d-flex gap-1 justify-content-center">
                          <Button
                            variant="outline-primary"
                            size="sm"
                            onClick={() => carregarParaEdicao(config, index)}
                            disabled={editando}
                            style={{ fontSize: '10px', padding: '2px 6px' }}
                            title="Editar"
                          >
                            ✏️
                          </Button>
                          <Button
                            variant="outline-info"
                            size="sm"
                            onClick={() => duplicarConfiguracao(config)}
                            disabled={editando}
                            style={{ fontSize: '10px', padding: '2px 6px' }}
                            title="Duplicar"
                          >
                            📋
                          </Button>
                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() => removerConfiguracao(index)}
                            disabled={editando}
                            style={{ fontSize: '10px', padding: '2px 6px' }}
                            title="Excluir"
                          >
                            🗑️
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};



// Componente Select2 para Status de Congelamento
const StatusCongeladosSelect2Component = React.forwardRef((props, ref) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    // Status fixos para congelados
    const statusCongelados = [
      { value: 'pago', label: 'Pago' },
      { value: 'pendente', label: 'Pendente' },
      { value: 'vencido', label: 'Vencido' }
    ];
    setOptions(statusCongelados);
  }, []);

  const [selectedValues, setSelectedValues] = useState([]);

  React.useImperativeHandle(ref, () => ({
    getValue: () => selectedValues,
    setValue: (values) => setSelectedValues(values || [])
  }));

  const handleChange = (values) => {
    setSelectedValues(values || []);
  };

  return (
    <Select
      isMulti
      options={options}
      value={selectedValues}
      onChange={handleChange}
      placeholder="Selecione os status..."
      styles={{
        control: (base) => ({
          ...base,
          minHeight: '32px',
          fontSize: '13px',
          borderColor: '#ced4da'
        }),
        menu: (base) => ({
          ...base,
          fontSize: '13px',
          zIndex: 9999
        })
      }}
    />
  );
});


// Componente principal de configuração de cobrança de congelados
const ConfiguracaoCobrancaCongelados = ({ onSuccess, onError, onToggle }) => {
  const [configuracoes, setConfiguracoes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editando, setEditando] = useState(false);
  const [indiceEditando, setIndiceEditando] = useState(null);

  const statusRef = useRef();
  const diasAntesRef = useRef();
  const horarioEnvioRef = useRef();
  const mensagemRef = useRef();
  const diasSemanaRef = useRef();

  useEffect(() => {
    carregarConfiguracoes();
  }, []);

  const carregarConfiguracoes = async () => {
    try {
      const dados = await pegarConfiguracao('AUTOMACAO_COBRANCA_CONGELADOS_CONFIGURACAO');
      const configs = dados?.valor ? JSON.parse(dados.valor) : [];
      setConfiguracoes(Array.isArray(configs) ? configs : []);
    } catch (error) {
      console.error('Erro ao carregar configurações:', error);
      setConfiguracoes([]);
    }
  };

  const salvarConfiguracoes = async (novasConfigs) => {
    try {
      await alterarConfiguracao('AUTOMACAO_COBRANCA_CONGELADOS_CONFIGURACAO', JSON.stringify(novasConfigs));
      setConfiguracoes(novasConfigs);
    } catch (error) {
      onError('Erro ao salvar configurações.');
    }
  };

  const limparFormulario = () => {
    statusRef.current?.setValue(null);
    diasAntesRef.current?.setValue(null);
    diasSemanaRef.current?.setValue(null);
    if (horarioEnvioRef.current) horarioEnvioRef.current.value = '';
    if (mensagemRef.current) mensagemRef.current.value = '';
    setEditando(false);
    setIndiceEditando(null);
  };

  const carregarParaEdicao = (config, index) => {
    setEditando(true);
    setIndiceEditando(index);

    // Carregar dados nos campos
    if (statusRef.current) {
      statusRef.current.setValue(config.Status.map(s => ({
        value: s.id,
        label: s.Nome
      })));
    }

    if (diasAntesRef.current) {
      diasAntesRef.current.setValue([{
        value: config.DiasAntes,
        label: config.DiasAntesLabel
      }]);
    }

    if (horarioEnvioRef.current) {
      horarioEnvioRef.current.value = config.HorarioEnvio;
    }

    if (mensagemRef.current) {
      mensagemRef.current.value = config.MensagemConteudo || '';
    }

    if (diasSemanaRef.current && config.DiasSemana) {
      const diasSelect2 = config.DiasSemana.map(dia => ({
        value: dia.value || dia.id || dia,
        label: dia.label || dia.nome || getDiaNome(dia.value || dia.id || dia)
      }));
      diasSemanaRef.current.setValue(diasSelect2);
    }
  };

  const duplicarConfiguracao = (config) => {
    setEditando(false);
    setIndiceEditando(null);

    if (statusRef.current) {
      statusRef.current.setValue(config.Status.map(s => ({
        value: s.id,
        label: s.Nome
      })));
    }

    if (diasAntesRef.current) {
      diasAntesRef.current.setValue([{
        value: config.DiasAntes,
        label: config.DiasAntesLabel
      }]);
    }

    if (horarioEnvioRef.current) {
      horarioEnvioRef.current.value = config.HorarioEnvio;
    }

    if (mensagemRef.current) {
      mensagemRef.current.value = config.MensagemConteudo || '';
    }

    if (diasSemanaRef.current && config.DiasSemana) {
      const diasSelect2 = config.DiasSemana.map(dia => ({
        value: dia.value || dia.id || dia,
        label: dia.label || dia.nome || getDiaNome(dia.value || dia.id || dia)
      }));
      diasSemanaRef.current.setValue(diasSelect2);
    }

    onSuccess('Configuração carregada para duplicação. Ajuste os campos necessários e clique em "Adicionar".');
  };

  const cancelarEdicao = () => {
    limparFormulario();
  };

  const getDiaNome = (id) => {
    const dias = {
      'TodosDias': 'Todos os dias',
      1: 'Domingo',
      2: 'Segunda-feira',
      3: 'Terça-feira',
      4: 'Quarta-feira',
      5: 'Quinta-feira',
      6: 'Sexta-feira',
      7: 'Sábado'
    };
    return dias[id] || 'Desconhecido';
  };

  const getDiaAbreviacao = (nome) => {
    const abrevs = {
      'Todos os dias': 'Todos',
      'Domingo': 'Dom',
      'Segunda-feira': 'Seg',
      'Terça-feira': 'Ter',
      'Quarta-feira': 'Qua',
      'Quinta-feira': 'Qui',
      'Sexta-feira': 'Sex',
      'Sábado': 'Sáb'
    };
    return abrevs[nome] || nome.substring(0, 3);
  };

  const adicionarConfiguracao = async () => {
    setLoading(true);

    try {
      const statusSelecionados = statusRef.current?.getValue() || [];
      const diasAntesSelecionados = diasAntesRef.current?.getValue() || [];
      const diasSemanaSelecionados = diasSemanaRef.current?.getValue() || [];
      const horarioEnvio = horarioEnvioRef.current?.value;
      const mensagemConteudo = mensagemRef.current?.value;

      // Validações
      if (statusSelecionados.length === 0) {
        onError('Selecione pelo menos um status.');
        return;
      }
      if (diasAntesSelecionados.length === 0) {
        onError('Selecione dias antes.');
        return;
      }
      if (!horarioEnvio) {
        onError('Preencha o horário de envio.');
        return;
      }
      if (diasSemanaSelecionados.length === 0) {
        onError('Selecione pelo menos um dia da semana.');
        return;
      }

      const novaConfiguracao = {
        Status: statusSelecionados.map(s => ({ Nome: s.label, id: s.value })),
        DiasAntes: diasAntesSelecionados[0].value,
        DiasAntesLabel: diasAntesSelecionados[0].label,
        DiasSemana: diasSemanaSelecionados,
        HorarioEnvio: horarioEnvio,
        MensagemConteudo: mensagemConteudo
      };

      let configsAtualizadas;

      if (editando && indiceEditando !== null) {
        configsAtualizadas = [...configuracoes];
        configsAtualizadas[indiceEditando] = novaConfiguracao;
        await salvarConfiguracoes(configsAtualizadas);
        onSuccess('Configuração atualizada com sucesso!');
      } else {
        configsAtualizadas = [...configuracoes, novaConfiguracao];
        await salvarConfiguracoes(configsAtualizadas);
        onSuccess('Configuração adicionada com sucesso!');
      }

      limparFormulario();
    } catch (error) {
      onError('Erro ao adicionar configuração.');
    } finally {
      setLoading(false);
    }
  };

  const removerConfiguracao = async (index) => {
    if (!window.confirm('Tem certeza que deseja excluir esta configuração?')) {
      return;
    }

    const novasConfigs = [...configuracoes];
    novasConfigs.splice(index, 1);
    await salvarConfiguracoes(novasConfigs);
    onSuccess('Configuração removida com sucesso!');
  };

  return (
    <div className="bg-white mb-3" style={{ border: '1px solid #dee2e6' }}>
      <div style={{ backgroundColor: '#f8f9fa', padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>
        <h6 className="mb-0" style={{ color: '#495057', fontWeight: '600' }}>💰 Cobrança de Congelados</h6>
      </div>
      <div className="p-3">
        {/* Switch para habilitar/desabilitar */}
        <Row className="align-items-center mb-3">
          <Col md={2}>
            <Form.Label className="small fw-medium text-muted">Habilitado:</Form.Label>
          </Col>
          <Col md={3}>
            <ConfiguracaoSwitch
              tipo="AUTOMACAO_COBRANCA_CONGELADOS"
              onSuccess={onSuccess}
              onError={onError}
              onToggle={onToggle}
            />
          </Col>
        </Row>

        {/* Indicador de modo de edição */}
        {editando && (
          <Alert variant="info" className="mb-3" style={{ fontSize: '13px' }}>
            ✏️ <strong>Modo de edição:</strong> Editando configuração #{indiceEditando + 1}
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={cancelarEdicao}
              style={{ float: 'right', fontSize: '11px' }}
            >
              Cancelar
            </Button>
          </Alert>
        )}

        {/* Indicador de modo de duplicação */}
        {!editando && (statusRef.current?.getValue()?.length > 0 || diasAntesRef.current?.getValue()?.length > 0) && (
          <Alert variant="success" className="mb-3" style={{ fontSize: '13px' }}>
            📋 <strong>Modo de duplicação:</strong> Campos preenchidos com configuração existente. Ajuste conforme necessário e clique em "Adicionar".
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={limparFormulario}
              style={{ float: 'right', fontSize: '11px' }}
            >
              Limpar
            </Button>
          </Alert>
        )}

        {/* Formulário de adição/edição */}
        <Row className="mb-3">
          <Col md={3}>
            <Form.Label className="small fw-medium text-muted">Status</Form.Label>
            <StatusCongeladosSelect2Component ref={statusRef} />
          </Col>
          <Col md={3}>
            <Form.Label className="small fw-medium text-muted">Notifica</Form.Label>
            <DiasAntesSelect2Component ref={diasAntesRef} />
          </Col>
          <Col md={3}>
            <Form.Label className="small fw-medium text-muted">Dias da semana para envio</Form.Label>
            <DiasSemanaSelect2Component ref={diasSemanaRef} />
          </Col>
        </Row>

        {/* Variáveis disponíveis */}
        <div className="mb-3">
          <small className="text-muted d-block mb-2"><strong>Variáveis disponíveis para cobranças:</strong></small>
          <div className="d-flex flex-wrap gap-1">
            {['$nomePaciente', '$nomeConjuge', '$tipoMaterial', '$dataCongelamento', '$nomeMedico', '$dataVencimento', '$valorASerPago'].map((variavel, index) => (
              <Badge key={index} bg="light" text="dark" className="small">{variavel}</Badge>
            ))}
          </div>
        </div>

        {/* Mensagem personalizada */}
        <Row className="mb-3">
          <Col md={12}>
            <Form.Label className="small fw-medium text-muted">Mensagem personalizada</Form.Label>
            <Form.Control
              ref={mensagemRef}
              as="textarea"
              rows={3}
              placeholder="Digite a mensagem de cobrança..."
              style={{ fontSize: '13px' }}
            />
          </Col>
        </Row>

        {/* Horário e botão adicionar/atualizar */}
        <Row className="align-items-end">
          <Col md={3}>
            <Form.Label className="small fw-medium text-muted">Horário de início dos envios</Form.Label>
            <Form.Control
              ref={horarioEnvioRef}
              type="time"
              size="sm"
              style={{ fontSize: '13px' }}
            />
          </Col>
          <Col md={2}>
            <Button
              variant={editando ? "warning" : "success"}
              onClick={adicionarConfiguracao}
              disabled={loading}
              style={{
                backgroundColor: editando ? '#ffc107' : '#43a047',
                borderColor: editando ? '#ffc107' : '#43a047',
                fontSize: '13px',
                color: editando ? '#000' : 'white',
                width: '100%'
              }}
            >
              {loading ? <Spinner size="sm" /> : (editando ? 'Atualizar' : 'Adicionar')}
            </Button>
          </Col>
        </Row>

        {/* Tabela de configurações */}
        {configuracoes.length > 0 && (
          <div className="mt-4">
            <div className="table-responsive">
              <Table className="mb-0" style={{ fontSize: '12px' }}>
                <thead style={{ backgroundColor: '#f8f9fa' }}>
                  <tr>
                    <th style={{ padding: '8px 12px', fontWeight: '600', color: '#495057' }}>Status</th>
                    <th style={{ padding: '8px 12px', fontWeight: '600', color: '#495057' }}>Dias antes</th>
                    <th style={{ padding: '8px 12px', fontWeight: '600', color: '#495057' }}>Dias da semana</th>
                    <th style={{ padding: '8px 12px', fontWeight: '600', color: '#495057' }}>Horário</th>
                    <th style={{ padding: '8px 12px', fontWeight: '600', color: '#495057' }}>Mensagem</th>
                    <th style={{ padding: '8px 12px', fontWeight: '600', color: '#495057', width: '150px' }}>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {configuracoes.map((config, index) => (
                    <tr key={index} style={{ borderBottom: '1px solid #f0f0f0' }}>
                      <td style={{ padding: '8px 12px', verticalAlign: 'top' }}>
                        {config.Status?.map(s => s.Nome).join(', ')}
                      </td>
                      <td style={{ padding: '8px 12px', verticalAlign: 'top' }}>{config.DiasAntesLabel}</td>
                      <td style={{ padding: '8px 12px', verticalAlign: 'top' }}>
                        <div className="d-flex flex-wrap" style={{ gap: '4px' }}>
                          {config.DiasSemana?.map((dia, idx) => (
                            <Badge
                              key={idx}
                              bg="primary"
                              style={{
                                fontSize: '12px',
                                backgroundColor: '#43a047',
                                borderRadius: '3px',
                                padding: '2px 4px',
                                color: 'white',
                                marginRight: '2px',
                                marginBottom: '2px'
                              }}
                            >
                              {getDiaAbreviacao(dia.label || dia.nome || getDiaNome(dia.value || dia.id || dia))}
                            </Badge>
                          )) || <small className="text-muted">Nenhum dia selecionado</small>}
                        </div>
                      </td>
                      <td style={{ padding: '8px 12px', verticalAlign: 'top' }}>{config.HorarioEnvio}</td>
                      <td style={{ padding: '8px 12px', verticalAlign: 'top', maxWidth: '200px' }}>
                        <div style={{
                          background: 'linear-gradient(135deg, #ffecb3 0%, #ffd54f 100%)',
                          padding: '6px 8px',
                          borderRadius: '4px',
                          borderLeft: '3px solid #ff9800',
                          fontSize: '11px',
                          lineHeight: '1.3',
                          maxHeight: '60px',
                          overflowY: 'auto',
                          wordBreak: 'break-word'
                        }}>
                          {config.MensagemConteudo}
                        </div>
                      </td>
                      <td style={{ padding: '8px 12px', textAlign: 'center' }}>
                        <div className="d-flex gap-1 justify-content-center">
                          <Button
                            variant="outline-primary"
                            size="sm"
                            onClick={() => carregarParaEdicao(config, index)}
                            disabled={editando}
                            style={{ fontSize: '10px', padding: '2px 6px' }}
                            title="Editar"
                          >
                            ✏️
                          </Button>
                          <Button
                            variant="outline-info"
                            size="sm"
                            onClick={() => duplicarConfiguracao(config)}
                            disabled={editando}
                            style={{ fontSize: '10px', padding: '2px 6px' }}
                            title="Duplicar"
                          >
                            📋
                          </Button>
                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() => removerConfiguracao(index)}
                            disabled={editando}
                            style={{ fontSize: '10px', padding: '2px 6px' }}
                            title="Excluir"
                          >
                            🗑️
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AutomacoesView;